/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { InquirySellerAgencyResponseDto } from './inquirySellerAgencyResponseDto';
import type { InquirySellerContactResponseDtoRole } from './inquirySellerContactResponseDtoRole';

export interface InquirySellerContactResponseDto {
  name: string;
  /** @nullable */
  phoneHint: string | null;
  /** @nullable */
  phone: string | null;
  /** @nullable */
  photoUrl: string | null;
  /** @nullable */
  role: InquirySellerContactResponseDtoRole;
  /** @nullable */
  agency: InquirySellerAgencyResponseDto | null;
}
